import { combineReducers } from "redux";

import app from "./app/app-reducer";
import link from "./link/link-reducer";
import org from "./org/org-reducer";
import user from "./user/user-reducer";

export const rootReducer = combineReducers({ app, link, org, user });

export type ReduxState = ReturnType<typeof rootReducer>;
